<template>
  <CModal
    @mtdclosemodal="mtdClose"
    :show="boo_modal"
    :title="title"
    :product="product"
    :size="'md'"
    :centered="true"
    :btn_cancel="true"
    :btn_ok="true"
    :booTitile="true"
  >
    <CRow>
      <CCol xs="12" sm="12" md="12" lg="12" xl="12">
        <CInput
          label="Producto"
          :value="tempProduct?.product.name || ''"
          readonly
        />
      </CCol>
      <!-- <CCol xs="12" sm="12" md="3" lg="3" xl="3" v-if="tempProduct.kit != null">
        <label>Cambiar</label>
        <br>
        <button
          class="btn btn-sm btn-info py-2 px-4 mx-2"
          @click="mtdChangeProduct"
        >
          <i class="fas fa-recycle"></i>
        </button>
      </CCol> -->
      <CCol xs="12" sm="12" md="12" lg="12" xl="12" v-if="change">
        <label> Cambiar por:</label>
        <select v-model="prodNew" class="form-control">
          <option :value={} disabled selected>Seleccione un producto</option>
          <option v-for="(item, index) in data_product" :key="index" :value="item">
            {{ item.label }}
          </option>
        </select>
      </CCol>
      <CCol class="mt-2" xs="12" sm="12" md="12" lg="12" xl="12" v-if="change && Object.keys(prodNew).length > 0" >
        <CInput
          label="Precio a Cambiar"
          :value="prodNew.price"
          readonly
        />
      </CCol>
      <CCol
        v-if="tempProduct?.product.name?.includes('ELECTRIFICADOR') && Object.keys(prodNew).length == 0 "
        xs="12"
        sm="12"
        md="12"
        lg="12"
        xl="12"
      >
        <CInput
          label="Código"
          placeholder="Digite Código"
          v-model="tempProduct.code"
        />
      </CCol>
    </CRow>
    <cRow>
      <CCol
        xs="12"
        sm="12"
        md="12"
        lg="8"
        xl="8"
        class="d-flex justify-content-center align-items-center"
      >
        <button
          :disabled="tempProduct.kit && Object.keys(prodNew).length == 0"
          @click="decreaseQuantity"
          class="btn btn-sm btn-info py-2 px-4 menos mx-2"
        >
          <i class="fas fa-minus"></i>
        </button>
        <CInput
          label="Cantidad"
          v-model="tempProduct.quantity"
          @keypress="isNumber()"
          class="text-center align-items-center"
          @input="validationStock()"
          :disabled="tempProduct.kit && Object.keys(prodNew).length == 0"
        />
        <button
          :disabled="tempProduct.kit && Object.keys(prodNew).length == 0"
          @click="increaseQuantity"
          class="btn btn-sm btn-primary py-2 px-4 mx-2 mas"
        >
          <i class="fas fa-plus"></i>
        </button>
      </CCol>
      <CCol xs="12" sm="12" md="12" lg="4" xl="4">
        <CInput label="Precio" :value="tempProduct.price || 1" readonly />
      </CCol>
    </cRow>

    <!-- Parte Inferior: Tabla de Stocks -->
    <div class="border-top pt-3">
      <h6 class="mb-3 text-secondary"><strong>STOCKS POR ALMACÉN</strong></h6>
      <div class="table-responsive" style="max-height: 270px; overflow-y: auto;">
        <table class="table table-sm table-striped table-bordered text-center align-middle">
          <thead class="table-dark">
            <tr>
              <th>SEDE</th>
              <th>STOCK</th>
              <th v-if="($store.getters.get_rol && $store.getters.get_rol.id == 4)">P. COMPRA</th>
              <th>P. VENTA</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(st, idx) in (tempProduct.productObj?.stocks || tempProduct.stocks || [])" :key="idx">
              <td class="text-start">
                <!-- <strong>{{ st.sede_name || '-' }}</strong> - {{ st.almacen_name || '-' }} -->
                <strong>{{ st.sede_name || '-' }}</strong> <!-- - {{ st.almacen_name || '-' }} -->
              </td>
              <td>
                <span class="badge" :class="getStockBadgeClass(st.stock)">
                  {{ st.stock }}
                </span>
              </td>
              <td v-if="($store.getters.get_rol && $store.getters.get_rol.id == 4)">S/{{ st.purchase_price || st.product_unit?.product?.price?.[0]?.purchase_price || tempProduct.productObj?.purchase_price || '0.00' }}</td>
              <td class="text-success fw-bold">S/{{ st.sale_price || st.product_unit?.product?.price?.[0]?.sale_price || tempProduct.productObj?.price || '0.00' }}</td>
            </tr>
            <tr v-if="!(tempProduct.productObj?.stocks || tempProduct.stocks)?.length">
              <td colspan="5" class="text-muted text-center py-3">No hay registros de stock en otros almacenes.</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <template #footer>
      <button @click="mtdClose" class="btn btn-sm">
        <i class="fa fa-times" />&nbsp;Cerrar
      </button>
      <button @click="save" class="btn btn-info btn-sm"><i class="fas fa-save"></i> Guardar</button>
      &nbsp;
    </template>
  </CModal>
</template>
<script>
import CModal from "../../../../shared/modals/cModalFormCom.vue";

export default {
  name: "c-update-sale-modal",
  components: {
    CModal,
  },
  data() {
    return {
      tempProduct: { ...this.product }, // Copia temporal del producto,
      change: false,
      prodNew:{}
    };
  },
  props: {
    title: String,
    boo_modal: Boolean,
    product: Object,
    data_product: Array
  },
  created() {},
  watch: {
    boo_modal(newVal) {
      if (newVal) {
        // this.change = this.product.kit == null?false:true;
        this.tempProduct = { ...this.product }; // Resetear la copia temporal al abrir el modal
        console.log(this.tempProduct);

      }
    },
  },
  methods: {
    mtdClose() {
      this.$emit("closeModalUpdateSale");
      this.prodNew={}
      this.change =false
    },
    increaseQuantity() {
      this.tempProduct.quantity = +this.tempProduct.quantity + 1;
    },
    decreaseQuantity() {
      if (this.tempProduct.quantity > 1) {
        this.tempProduct.quantity -= 1;
      }
    },
    validationStock() {
      const quantity = parseInt(event.target.value, 10);
      if (quantity < 1) {
        this.tempProduct.quantity = 1;
      }
      // const stock = parseInt(this.tempProduct.stock, 10);
      // if (quantity > this.tempProduct.stock) {
      //   this.tempProduct.quantity = parseInt(this.tempProduct.stock, 10);
      //   Swal.fire({
      //     title: "La cantidad excede del stock disponible",
      //     icon: "warning",
      //   });
      // } else if (quantity < 1) {
      //   this.tempProduct.quantity = 1;
      // }
    },
    save() {
      if(this.change){
        this.tempProduct.product.id = this.prodNew.value;
        this.tempProduct.product.name = this.prodNew.label;
        this.tempProduct.stock=this.prodNew.stock;
        this.tempProduct.unit.id = this.prodNew.value_unit;
        this.tempProduct.unit.name = this.prodNew.label_unit
        this.tempProduct.price = this.prodNew.price
      }
      if (
        parseFloat(this.tempProduct.quantity) >
        parseFloat(this.tempProduct.stock)
      ) {
        Swal.fire({
          title: "La cantidad excede del stock, deberá reponerse luego",
          icon: "warning",
        });
      }
      this.$emit("updateProduct", this.tempProduct);
      this.$emit("closeModalUpdateSale");
      this.prodNew={}
      this.change =false
      // Envía los datos al componente padre
      // Cierra el modal
    },
    isNumber: function (evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    mtdChangeProduct(){
      this.change = !this.change
      if(!this.change){
        this.prodNew={}
      }
    },
    getStockBadgeClass(stock) {
      if (stock <= 5) return 'badge-danger';
      if (stock <= 10) return 'badge-warning';
      return 'badge-success';
    }
  },
};
</script>
<style scoped>
.menos {
  margin-top: 11px;
}

.mas {
  margin-top: 11px;
}
</style>
